import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";

import moduleAuth from '@/store/modules/auth/moduleAuth';
import modulePrograms from '@/store/modules/programs/modulePrograms';
import moduleCommon from '@/store/modules/common/moduleCommon';

config.rawError = true;

const store = createStore({
  modules: {
    // AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    //

    moduleAuth,
    modulePrograms,
    moduleCommon,
  },
});

export default store;
